import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, Mail } from "lucide-react";

const fmt = (tz) => new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz }).format(new Date());

const Clocks = () => {
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 30000);
    return () => clearInterval(t);
  }, []);
  return (
    <span data-testid="footer-clocks">
      India {fmt("Asia/Kolkata")} IST · Your time {fmt(undefined)}
    </span>
  );
};

export const Footer = ({ config }) => (
  <footer className="border-t border-neutral-200/80 bg-[var(--ivory)]" data-testid="site-footer">
    <div className="mx-auto grid max-w-5xl gap-6 px-5 py-10 text-sm text-neutral-600 sm:grid-cols-[1.4fr_1fr]">
      <div className="space-y-2">
        <p className="font-display text-lg text-[#1f2328]">Welcome home, wherever you are.</p>
        <p data-testid="footer-operator">Operated by {config?.operator_name || "PropertiesforNRI.com"}</p>
        {config?.contact_email && (
          <a href={`mailto:${config.contact_email}`} className="inline-flex items-center gap-2 hover:text-[#1f2328]" data-testid="footer-email-link">
            <Mail className="h-4 w-4" /> {config.contact_email}
          </a>
        )}
        <p className="flex flex-wrap items-center gap-2">
          <Clock className="h-4 w-4" /> {config?.business_hours || "Mon–Sat, 10:00–19:00 IST"} · <Clocks />
        </p>
      </div>
      <div className="space-y-3 sm:text-right">
        <nav className="flex gap-4 sm:justify-end">
          <Link to="/privacy" className="hover:text-[#1f2328]" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/terms" className="hover:text-[#1f2328]" data-testid="footer-terms-link">Terms</Link>
          <Link to="/disclaimer" className="hover:text-[#1f2328]" data-testid="footer-disclaimer-link">Disclaimer</Link>
        </nav>
        <p className="text-xs uppercase tracking-[0.14em] text-neutral-500">MatchMaking powered by ConectR MatchMaking Technology</p>
        <p className="text-xs text-neutral-400">© {new Date().getFullYear()} PropertiesforNRI.com</p>
      </div>
    </div>
  </footer>
);
